export const Certificate = {
  BCC: "bcc",
  BCLAD: "bclad",
  CLAD: "clad",
  LDS: "lds",
  ELD_SDAIE: "eld_sdaie",
  TPSL: "tpsl",
  OTHER: "other",
} as const;

export type Certificate = (typeof Certificate)[keyof typeof Certificate];

export const CERTIFICATE_LABELS: Record<Certificate, string> = {
  [Certificate.BCC]: "BCC",
  [Certificate.BCLAD]: "BCLAD",
  [Certificate.CLAD]: "CLAD",
  [Certificate.LDS]: "LDS",
  [Certificate.ELD_SDAIE]: "ELD/SDAIE",
  [Certificate.TPSL]: "TPSL",
  [Certificate.OTHER]: "Other",
};
